<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="vehicles"
          @select="select"
          @select-all="select">
        <div slot="toolbar">
          <el-button v-if="addAuth" type="primary" @click="$refs.editPage.open(0)"> 新建 </el-button>
          <el-button v-if="printAuth" :disabled="!selection.length" type="primary" @click="$refs.printVehicleCode.open()"> 打印条码 </el-button>
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除 </el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="载具编号：">
              <el-input v-model.trim="filter.vehicleNo" placeholder="请输入载具编号" clearable/>
            </vm-search>
            <vm-search label="载具名称：">
              <el-input v-model.trim="filter.vehicleName" placeholder="请输入载具名称" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="55" prop="selection"/>
        <el-table-column prop="vehicleNo" align="center" label="载具编号" width="100"/>
        <el-table-column prop="vehicleName" align="left" label="载具名称" min-width="120"/>
        <el-table-column prop="length" align="center" label="长度" width="70"/>
        <el-table-column prop="width" align="center" label="宽度" width="70"/>
        <el-table-column prop="lengthLimit" align="center" label="限长" width="70"/>
        <el-table-column prop="widthLimit" align="center" label="限宽" width="70"/>
        <el-table-column prop="cubicUnitName" align="left" label="长度单位" min-width="180"/>
        <el-table-column prop="load" align="center" label="载重" width="70"/>
        <el-table-column prop="loadUnitName" align="center" label="载重单位" width="70"/>
        <el-table-column prop="creatorName" align="center" label="创建人" width="100"/>
        <el-table-column prop="createTime" align="center" label="创建时间" width="150"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            prop="action"
            fixed="right"
            width="120">
          <template slot-scope="scope">
            <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open(scope.row.pkId)"> 编辑 </el-button>
            <el-button v-if="delAuth" type="danger" @click="deleteRow(scope.row.pkId)"> 删除 </el-button>
          </template>
        </el-table-column>
      </vm-table>
      <vehicle-edit ref="editPage" @save-success="getList(-1)"/>
      <print-vehicle-code ref="printVehicleCode" :selection="selection"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import VehicleEdit from "./VehicleEdit";
  import PrintVehicleCode from "./PrintVehicleCode";
  export default {
    name: "VehicleList",
    components: { VehicleEdit, VmTable, VmSearch, PrintVehicleCode },
    data() {
      return {
        addAuth: this.$auth(246),
        printAuth: this.$auth(247),
        delAllAuth: this.$auth(248),
        editAuth: this.$auth(249),
        delAuth: this.$auth(250),
        selection: [],
        filter: {
          vehicleNo: "",
          vehicleName: "",
        },
      };
    },

    mounted() {
      this.$refs.vmTable.getList(1);
    },

    methods: {
      // 查询
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      select(selection) {
        this.selection = selection;
      },

      // 单个删除
      deleteRow(pkId) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "vehicles", pkId).then((resp) => {
            if (resp.success) {
              this.getList(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 批量删除
      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkId);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "vehicles/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.getList(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },
    },
  };
</script>
